(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glimtiq-card-assets"] && !Shopify.designMode) return;
  try {
    const glimtiqPreviewQueue=[];
  let glimtiqPreviewBusy=false,glimtiqPreviewBudget=24;
  const glimtiqCanWarm=()=>{const c=navigator.connection;return document.readyState==='complete'&&!document.hidden&&!c?.saveData&&(!c?.effectiveType||c.effectiveType==='4g');};
  const glimtiqWarmNext=async()=>{
    if(glimtiqPreviewBusy||!glimtiqCanWarm()||glimtiqPreviewBudget<=0)return;
    const card=glimtiqPreviewQueue.shift();if(!card)return;
    if(!card.isConnected||!card.previewVisible){glimtiqWarmNext();return;}
    const index=card.buttons.findIndex((b,i)=>i>0&&!card.images[i]);
    if(index<0){glimtiqWarmNext();return;}
    glimtiqPreviewBusy=true;glimtiqPreviewBudget--;
    try{await card.prepare(index,true);}catch{}
    glimtiqPreviewBusy=false;
    if(card.previewVisible&&card.isConnected)glimtiqPreviewQueue.push(card);
    setTimeout(glimtiqWarmNext,400);
  };
  const glimtiqPreviewObserver=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      const card=entry.target.closest('glimtiq-product-card');if(!card)return;
      card.previewVisible=entry.isIntersecting&&entry.intersectionRatio>=.35;clearTimeout(card.warmTimer);
      if(card.previewVisible)card.warmTimer=setTimeout(()=>{if(card.previewVisible&&!glimtiqPreviewQueue.includes(card)){glimtiqPreviewQueue.push(card);glimtiqWarmNext();}},900);
    });
  },{threshold:[0,.35]});
  window.addEventListener('load',glimtiqWarmNext,{once:true});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)glimtiqWarmNext();});
  if (!customElements.get('glimtiq-product-card')) customElements.define('glimtiq-product-card',class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      this.ready=true;this.photo=this.querySelector('.gpc-photo');this.buttons=[...this.querySelectorAll('.gpc-preview')];this.images=[this.photo?.querySelector('img')];this.current=0;this.requested=0;this.abort=new AbortController();const options={signal:this.abort.signal};
      if(this.buttons.length>1&&this.photo)glimtiqPreviewObserver.observe(this.photo);
      this.photo?.addEventListener('pointermove',e=>{
        if(e.pointerType!=='mouse'||!matchMedia('(hover:hover) and (pointer:fine) and (min-width:768px)').matches||this.buttons.length<2)return;
        const rect=this.photo.getBoundingClientRect();const index=1+Math.min(this.buttons.length-2,Math.max(0,Math.floor((e.clientX-rect.left)/rect.width*(this.buttons.length-1))));
        this.setAttribute('data-preview-active','');this.show(index);
      },options);
      this.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){this.removeAttribute('data-preview-active');this.show(0);}},options);
      this.buttons.forEach((button,i)=>{
        button.addEventListener('click',()=>this.show(i),options);
        button.addEventListener('keydown',e=>{const start=matchMedia('(hover:hover) and (pointer:fine) and (min-width:768px)').matches?1:0;let next=i;if(e.key==='ArrowRight')next=i+1>=this.buttons.length?start:i+1;else if(e.key==='ArrowLeft')next=i-1<start?this.buttons.length-1:i-1;else if(e.key==='Home')next=start;else if(e.key==='End')next=this.buttons.length-1;else return;e.preventDefault();this.buttons[next].focus();this.show(next);},options);
      });
      this.querySelector('.gpc-add')?.addEventListener('submit',e=>this.add(e),options);
    }
    async prepare(index,background=false) {
      if(!this.images[index]){
        const template=this.querySelector(`template[data-preview="${index}"]`);if(!template)return;
        const image=template.content.querySelector('img').cloneNode(true);image.hidden=true;image.fetchPriority=background?'low':'auto';image.sizes=`${Math.ceil(this.photo.clientWidth)}px`;this.images[index]=image;this.photo.append(image);
      }
      const image=this.images[index];if(!image)return;
      if(!background)image.fetchPriority='auto';
      if(!image.complete||!image.naturalWidth)await image.decode();
      return image;
    }
    async show(index) {
      if(index===this.requested)return;this.requested=index;
      this.photo.setAttribute('aria-busy','true');
      let image;
      try{image=await this.prepare(index);}catch{if(this.requested===index){this.requested=this.current;this.photo.removeAttribute('aria-busy');}return;}
      if(this.requested!==index)return;
      this.photo.removeAttribute('aria-busy');if(!image)return;
      const previous=this.images[this.current],direction=index>this.current?1:-1;
      this.images.forEach(img=>{if(img){img.getAnimations().forEach(a=>a.cancel());img.hidden=true;img.style.zIndex='';}});
      image.hidden=false;
      if(previous&&previous!==image&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
        previous.hidden=false;previous.style.zIndex='1';image.style.zIndex='2';
        previous.animate([{transform:'translateX(0)'},{transform:`translateX(${-direction*100}%)`}],{duration:320,easing:'cubic-bezier(.22,.61,.36,1)'});
        const animation=image.animate([{transform:`translateX(${direction*100}%)`},{transform:'translateX(0)'}],{duration:320,easing:'cubic-bezier(.22,.61,.36,1)'});
        animation.finished.then(()=>{if(this.current===index)previous.hidden=true;}).catch(()=>{});
      }
      this.current=index;
      this.buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(index===i)));
    }
    async add(event) {
      const drawer=document.querySelector('cart-drawer');if(!drawer)return;
      event.preventDefault();event.stopPropagation();const form=event.currentTarget;const button=form.querySelector('button');if(button.disabled)return;
      const status=this.querySelector('.gpc-status');status.textContent='';button.disabled=true;button.setAttribute('aria-busy','true');let added=false;
      try {
        const data=new FormData(form);data.append('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));data.append('sections_url',location.pathname);
        const response=await fetch(form.action+'.js',{method:'POST',body:data,headers:{Accept:'application/json'}});const state=await response.json();
        if(!response.ok||state.status)throw new Error(state.description||this.dataset.error);
        added=true;drawer.setActiveElement(button);drawer.classList.remove('is-empty');drawer.renderContents(state);
      } catch(error) {if(added){location.assign(this.dataset.cartUrl);return;}status.textContent=error.message||this.dataset.error;}
      finally {button.disabled=false;button.removeAttribute('aria-busy');}
    }
    disconnectedCallback(){this.abort?.abort();clearTimeout(this.warmTimer);if(this.photo)glimtiqPreviewObserver.unobserve(this.photo);this.previewVisible=false;this.ready=false;}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glimtiq-collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glimtiq-collection-filters')) customElements.define('glimtiq-collection-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const form = this.querySelector('form');
      const button = this.querySelector('[data-gc-apply]');
      const count = this.querySelector('[data-gc-preview]');
      const status = this.querySelector('[data-gc-status]');
      const opener = this.querySelector('.gc-open');
      this.opener = opener;
      const toolbar = this.querySelector('.gc-toolbar');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      const collectionSection = this.closest('.glimtiq-collection');
      this.updateVisibility = () => {
        this.visibilityFrame = null;
        const grid = collectionSection?.querySelector('#product-grid') || collectionSection;
        const bounds = grid?.getBoundingClientRect();
        const viewport = window.innerHeight;
        const overlay = document.querySelector('header-drawer details[open], details-modal details[open], cart-drawer.active, modal-dialog[open], dialog[open]');
        const hidden = this.mobileQuery.matches && (!bounds || bounds.top > viewport || bounds.bottom < viewport * 0.35 || !!overlay);
        if (opener.classList.contains('gc-outside') !== hidden) opener.classList.toggle('gc-outside', hidden);
        opener.inert = hidden;
        opener.setAttribute('aria-hidden', String(hidden));
      };
      this.scheduleVisibility = () => {
        if (!this.visibilityFrame) this.visibilityFrame = requestAnimationFrame(this.updateVisibility);
      };
      this.placeOpener = () => {
        if (this.mobileQuery.matches) document.body.append(opener);
        else toolbar.prepend(opener);
        this.scheduleVisibility();
      };
      this.mobileQuery.addEventListener('change', this.placeOpener);
      this.placeOpener();
      window.addEventListener('scroll', this.scheduleVisibility, { passive: true });
      window.addEventListener('resize', this.scheduleVisibility, { passive: true });
      this.gridObserver = new ResizeObserver(this.scheduleVisibility);
      if (collectionSection) this.gridObserver.observe(collectionSection);
      this.overlayObserver = new MutationObserver(records => {
        if (records.some(record => record.target !== opener)) this.scheduleVisibility();
      });
      this.overlayObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
      this.querySelector('[data-gc-desktop-sort]')?.addEventListener('change', event => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
      opener.addEventListener('click', () => { this.previousOverflow = document.body.style.overflow; dialog.showModal(); document.body.style.overflow = 'hidden'; });
      this.querySelector('.gc-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { document.body.style.overflow = this.previousOverflow || ''; this.updateVisibility(); if (!opener.inert) opener.focus({ preventScroll: true }); });
      this.querySelectorAll('.gc-ranges').forEach(track => {
        const low = track.querySelector('[data-range="min"]');
        const high = track.querySelector('[data-range="max"]');
        let drag = null;
        track.classList.add('gc-pointer');
        const applyPointer = event => {
          if (!drag || event.pointerId !== drag.id) return;
          const delta = event.clientX - drag.start;
          if (!drag.input) {
            if (Math.abs(delta) < 2) return;
            drag.input = delta < 0 ? low : high;
          }
          const input = drag.input;
          input.classList.add('gc-dragging');
          input.focus({ preventScroll: true });
          const raw = Math.round(Math.max(0, Math.min(1, (event.clientX - drag.left) / drag.width)) * Number(high.max));
          input.value = input === low ? Math.min(raw, Number(high.value)) : Math.max(raw, Number(low.value));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        };
        track.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          event.preventDefault();
          const bounds = track.getBoundingClientRect();
          const width = Math.max(1, bounds.width - 22);
          const left = bounds.left + 11;
          const maximum = Number(high.max) || 1;
          const lowX = left + Number(low.value) / maximum * width;
          const highX = left + Number(high.value) / maximum * width;
          const overlap = Math.abs(highX - lowX) < 22 && Math.abs(event.clientX - (lowX + highX) / 2) < 24;
          drag = { id: event.pointerId, start: event.clientX, left, width, input: overlap ? null : (Math.abs(event.clientX - lowX) < Math.abs(event.clientX - highX) ? low : high) };
          track.setPointerCapture(event.pointerId);
          if (!overlap) applyPointer(event);
        });
        track.addEventListener('pointermove', applyPointer);
        const finish = event => {
          if (!drag || event.pointerId !== drag.id) return;
          drag.input?.classList.remove('gc-dragging');
          drag = null;
          if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        };
        track.addEventListener('pointerup', finish);
        track.addEventListener('pointercancel', finish);
        track.addEventListener('lostpointercapture', finish);
      });
      form.addEventListener('input', event => {
        const price = event.target.closest('.gc-price');
        if (price) {
          const input = event.target;
          const key = input.dataset.range || input.dataset.price;
          if (key && input.value !== '') {
            const other = key === 'min' ? 'max' : 'min';
            const otherValue = Number(price.querySelector(`[data-price="${other}"]`).value);
            let value = Math.max(0, Math.min(Number(price.dataset.max), Number(input.value)));
            value = key === 'min' ? Math.min(value, otherValue) : Math.max(value, otherValue);
            price.querySelector(`[data-price="${key}"]`).value = value;
            price.querySelector(`[data-range="${key}"]`).value = value;
          }
        }
        clearTimeout(this.timer);
        this.controller?.abort();
        count.textContent = '…';
        this.timer = setTimeout(async () => {
          this.controller = new AbortController();
          const params = new URLSearchParams(new FormData(form));
          params.set('section_id', this.dataset.section);
          try {
            const response = await fetch(`${form.action}?${params}`, { signal: this.controller.signal });
            if (!response.ok) throw new Error('Unable to load results');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const next = html.querySelector('[data-gc-count]');
            if (!next) throw new Error('Missing result count');
            count.textContent = `(${next.dataset.gcCount})`;
            status.textContent = next.textContent;
          } catch (error) { if (error.name !== 'AbortError') count.textContent = ''; }
        }, 300);
      });
      form.addEventListener('submit', () => { button.setAttribute('aria-busy', 'true'); });
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); cancelAnimationFrame(this.visibilityFrame); window.removeEventListener('scroll', this.scheduleVisibility); window.removeEventListener('resize', this.scheduleVisibility); this.gridObserver?.disconnect(); this.overlayObserver?.disconnect(); this.mobileQuery?.removeEventListener('change', this.placeOpener); this.opener?.remove(); }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glimtiq-offer-strip"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glimtiq-offer-strip')) {
    customElements.define('glimtiq-offer-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const button = this.querySelector('button');
        this.querySelectorAll('.glimtiq-offer__track a').forEach(link => link.tabIndex = -1);
        const group = this.querySelector('.glimtiq-offer__group');
        const measure = () => this.style.setProperty('--offer-duration', `${group.getBoundingClientRect().width / Math.max(10, Number(this.dataset.speed) || 45)}s`);
        this.observer = new ResizeObserver(measure);
        this.observer.observe(group);
        measure();
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
        });
      }
      disconnectedCallback() { this.observer?.disconnect(); this.initialized = false; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glimtiq-product-experience"] && !Shopify.designMode) return;
  try {
    const prepareGlimtiqImages = (root = document) => {
    root.querySelectorAll('.glimtiq-product .product__media img, .card__media img').forEach((img) => {
      if (img.dataset.glimtiqObserved) return;
      img.dataset.glimtiqObserved = 'true';
      if (img.complete) return;
      const frame = img.closest('.media');
      if (!frame) return;
      frame.classList.add('glimtiq-image-pending');
      frame.setAttribute('aria-busy', 'true');
      const done = () => { frame.classList.remove('glimtiq-image-pending'); frame.removeAttribute('aria-busy'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  };
  prepareGlimtiqImages();
  document.querySelectorAll('product-recommendations').forEach((section) => {
    new MutationObserver(() => prepareGlimtiqImages(section)).observe(section, { childList: true, subtree: true });
  });
  document.addEventListener('shopify:section:load', () => prepareGlimtiqImages());
  document.addEventListener('toggle', (event) => {
    const opened = event.target;
    if (!opened.matches?.('.glimtiq-product details[name]') || !opened.open) return;
    opened.closest('product-info').querySelectorAll('details[name]').forEach((other) => {
      if (other !== opened && other.name === opened.name) other.open = false;
    });
  }, true);
  if (!customElements.get('glimtiq-sticky-buy')) {
    customElements.define('glimtiq-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
        this.button = this.querySelector('[data-sticky-submit]');
        this.price = this.querySelector('[data-sticky-price]');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        this.onClick = () => {
          const source = this.root.querySelector('.product-form__submit');
          if (source && !source.disabled && source.getAttribute('aria-disabled') !== 'true') source.click();
        };
        this.button.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.mobile.addEventListener('change', this.onScroll);
        this.observer = new MutationObserver(this.onScroll);
        const info = this.root.querySelector('.product__info-container');
        if (info) this.observer.observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
        this.sync();
      }
      sync() {
        const source = this.root.querySelector('.product-form__submit');
        if (!source) { this.hidden = true; return; }
        this.hidden = !(this.mobile.matches && source.getBoundingClientRect().bottom < 0);
        this.button.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
        this.button.textContent = source.querySelector('span')?.textContent.trim() || source.textContent.trim();
        const price = this.root.querySelector('.product__info-container .price');
        const value = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price-item--regular');
        if (value) this.price.textContent = value.textContent.trim();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        this.mobile?.removeEventListener('change', this.onScroll);
        this.button?.removeEventListener('click', this.onClick);
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glimtiq-product-header"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('glimtiq-product-header')) customElements.define('glimtiq-product-header',class extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.header=document.querySelector('.section-header');
      if(!this.header)return;
      this.desktop=matchMedia('(min-width:990px)');
      this.offer=document.querySelector('.glimtiq-offer[data-sticky-offer]');
      this.measure=()=>{
        document.documentElement.style.setProperty('--gph-header-height',`${this.header.getBoundingClientRect().height}px`);
        document.documentElement.style.setProperty('--header-height',`${this.header.offsetHeight}px`);
        document.documentElement.style.setProperty('--gph-offer-height',`${this.offer?.offsetHeight||0}px`);
      };
      this.update=()=>{
        this.frame=null;
        const compact=this.desktop.matches&&(window.scrollY>8||(document.body.classList.contains('gph-compact')&&window.scrollY>2));
        document.body.classList.toggle('gph-compact',compact);
      };
      this.scroll=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update);};
      this.observer=new ResizeObserver(this.measure);
      this.observer.observe(this.header);
      if(this.offer)this.observer.observe(this.offer);
      this.desktop.addEventListener('change',this.scroll);
      window.addEventListener('scroll',this.scroll,{passive:true});
      document.body.classList.add('gph-ready');
      this.measure();this.update();
    }
    disconnectedCallback(){
      this.observer?.disconnect();this.desktop?.removeEventListener('change',this.scroll);
      window.removeEventListener('scroll',this.scroll);cancelAnimationFrame(this.frame);
      document.body.classList.remove('gph-ready','gph-compact');this.ready=false;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glimtiq-product-highlights"] && !Shopify.designMode) return;
  try {
    const glimtiqIndiaParts=(date)=>{const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(date);return Object.fromEntries(parts.map(part=>[part.type,Number(part.value)]))};
  const glimtiqDateLabel=(utcDate)=>new Intl.DateTimeFormat('en-IN',{timeZone:'UTC',month:'short',day:'numeric'}).format(utcDate);
  if(!customElements.get('glimtiq-delivery-timeline'))customElements.define('glimtiq-delivery-timeline',class extends HTMLElement{connectedCallback(){const now=glimtiqIndiaParts(new Date());const base=Date.UTC(now.year,now.month-1,now.day);const dates={placed:0,shipped:1,delivered:4};Object.entries(dates).forEach(([key,days])=>{const element=this.querySelector(`[data-gph-date="${key}"]`);if(element)element.textContent=glimtiqDateLabel(new Date(base+days*86400000))})}});
  if(!customElements.get('glimtiq-daily-timer'))customElements.define('glimtiq-daily-timer',class extends HTMLElement{
    connectedCallback(){
      this.reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.update=()=>{
        const now=glimtiqIndiaParts(new Date());
        const left=86400-(now.hour*3600+now.minute*60+now.second);
        const pad=(value)=>String(value).padStart(2,'0');
        const values={hours:pad(Math.floor(left/3600)),minutes:pad(Math.floor(left%3600/60)),seconds:pad(left%60)};
        Object.entries(values).forEach(([key,value])=>this.updateUnit(this.querySelector(`[data-gph-unit="${key}"]`),value));
        this.querySelector('.gph-daily__clock').setAttribute('aria-label',`Time until midnight in India: ${values.hours} hours, ${values.minutes} minutes, ${values.seconds} seconds`);
      };
      this.update();
      this.timer=setInterval(this.update,1000);
    }
    updateUnit(unit,value){
      if(!unit||unit.dataset.value===value)return;
      const previous=unit.dataset.value;
      const still=unit.querySelector('[data-gph-still]');
      const top=unit.querySelector('[data-gph-top]');
      const bottom=unit.querySelector('[data-gph-bottom]');
      clearTimeout(unit.flipTimer);
      unit.classList.remove('is-flipping');
      still.textContent=previous||value;
      unit.dataset.value=value;
      if(!previous||this.reducedMotion){still.textContent=value;top.textContent=value;bottom.textContent=value;return}
      top.textContent=value;
      bottom.textContent=previous;
      unit.querySelector('[data-gph-old]').textContent=previous;
      unit.querySelector('[data-gph-new]').textContent=value;
      void unit.offsetWidth;
      unit.classList.add('is-flipping');
      unit.flipTimer=setTimeout(()=>{still.textContent=value;bottom.textContent=value;unit.classList.remove('is-flipping')},850);
    }
    disconnectedCallback(){
      clearInterval(this.timer);
      this.querySelectorAll('[data-gph-unit]').forEach(unit=>clearTimeout(unit.flipTimer));
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glimtiq-product-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-glimtiq-share-instagram]');
    if (!button) return;
    const status = button.closest('.glimtiq-product-share').querySelector('[data-glimtiq-share-status]');
    try {
      await navigator.clipboard.writeText(button.dataset.text);
      status.textContent = button.dataset.success;
    } catch {
      status.textContent = button.dataset.text;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
